import { useState } from 'react';

const faqs = [
  {
    question: 'Saatlik temizlik hizmetiniz var mı?',
    answer: 'VİAYPİİ Temizlik standart saatlik paket sistemiyle çalışmaz. Temizlenecek alan ve yapılacak işler değerlendirilerek hizmet kapsamı oluşturulur.',
  },
  {
    question: 'Nasıl fiyat alabilirim?',
    answer: 'Temizlenecek alanın kısa bir videosunu WhatsApp üzerinden gönderebilirsiniz. Alan incelendikten sonra yapılacak işe göre teklif hazırlanır.',
  },
  {
    question: 'Videoda neleri göstermeliyim?',
    answer: 'Temizlenecek odaları, zeminleri, camları ve özellikle işlem yapılmasını istediğiniz alanları genel olarak göstermeniz yeterlidir.',
  },
  {
    question: 'Temizlik malzemelerini benim almam gerekiyor mu?',
    answer: 'Hizmetin kapsamına göre profesyonel ekipman ve malzemeli çalışma planlanabilir. Detaylar teklif aşamasında netleştirilir.',
  },
  {
    question: 'Hangi alanlara hizmet veriyorsunuz?',
    answer: 'İnşaat sonrası alanlar, villa, residence, plaza, ofis, yazlık ev ve çeşitli profesyonel temizlik ihtiyaçları değerlendirilmektedir.',
  },
  {
    question: 'Hangi bölgelere geliyorsunuz?',
    answer: 'İstanbul Avrupa ve Anadolu Yakası, Silivri, Tekirdağ, Ankara ve uygun çevre bölgelerde talepler değerlendirilmektedir. Güncel hizmet uygunluğu için WhatsApp üzerinden bilgi alınabilir.',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="sss" className="bg-warm-cream py-16 md:py-24 lg:py-32">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-navy mb-4">
            SIK SORULAN SORULAR
          </h2>
          <p className="text-navy/60 text-base md:text-lg">
            Hizmetlerimiz hakkında merak edilenleri yanıtlıyoruz.
          </p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white border border-warm-sand rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left"
              >
                <span className="font-semibold text-navy text-sm md:text-base pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-gold text-xl md:text-2xl flex-shrink-0 transition-transform`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="text-navy/70 text-sm md:text-base leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}